import { formatDate, registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { PortalTranslationService } from '../services/portal-translation.service';

registerLocaleData(localeEl);

@Pipe({ name: 'portalDate', standalone: true, pure: false })
export class PortalDatePipe implements PipeTransform {
  private readonly translation = inject(PortalTranslationService);

  transform(value: string | number | Date | null | undefined, format = 'mediumDate'): string | null {
    if (value === null || value === undefined || value === '') return null;
    try {
      return formatDate(value, format, this.translation.currentLanguage() === 'el' ? 'el' : 'en-US');
    } catch {
      return null;
    }
  }
}
